import { useMutation } from 'apollo-3';

import { migrateMPProducts } from 'GraphQL/mutation/MyPath.mutation';

const useMigrateMPProducts = (props) => {
  const [migrateProducts, { data, loading, error, ...apolloUtils }] = useMutation(
    migrateMPProducts,
    { ...props }
  );

  return {
    mutate: migrateProducts,
    loading,
    error,
    ...apolloUtils,
  };
};

export default useMigrateMPProducts;
